<div *ngIf="fullscreen" class="full-screen" (click)="close()">
    <div class="loader">Loading...</div>
</div>

<div class="full-screen-off loading-container" *ngIf="!fullscreen && loaderStyle=='graph'">
    <div class="spinner spinner--steps2 icon-spinner-7" aria-hidden="false"></div>
</div>